import { Navigation } from './Navigation';
import { HeroSection } from './HeroSection';
import { ContactInfoBar } from './ContactInfoBar';

export function Header() {
  return (
    <header className="relative">
      {/* Navigation */}
      <Navigation />
      
      {/* Hero Section */}
      <HeroSection />
      
      {/* Contact Info Bar */}
      <ContactInfoBar />
    </header>
  );
}